<template>
  <modal :name="name"
         :adaptive="true"
         height="auto"
         width="380"
         @before-open="beforeOpen"
         @before-close="beforeClose">
    <div v-if="prospect" class="ut-px-10 ut-pt-12 ut-pb-8">
      <div v-show="page == 1">
        <h2 class="title">Set a reminder to follow up with
          {{ $options.filters.titleCase(prospect.contact.firstName) }}
          {{ $options.filters.titleCase(prospect.contact.lastName) }}</h2>
        <div class="form-group">
          <oa-datepicker id="follow-up-date" v-model="followUpDate"
                         :disabledDates="disabledDates"
                         v-gaEvent="{ category: gacategory,
                               action: 'Contact card - follow up pick date'}" />
          <span class="error ut-text-sm ut-font-bold"
                v-show="followUpDateError">
                Please select a date</span>
          <textarea v-model="followUpNote"
                    v-gaEvent="{ category: gacategory,
                               action: 'Contact card - follow up leave a note'}"
                    placeholder="Leave a note about this call" class="ut-h-32">
          </textarea>
        </div>
        <button @click="nextPage(page)"
                v-gaEvent="{ category: gacategory,
                               action: 'Contact card - follow up confirm'}"
                class="btn btn-green">Confirm</button>
        <button class="btn btn-small white-bg ut-ml-4"
                v-gaEvent="{ category: gacategory,
                               action: 'Contact card - follow up cancel'}"
                @click="closeModal()">Cancel</button>
      </div>

      <div v-show="page == 2" class="ut-text-center ut-px-3">
        <img class="ut-mb-8" src="@/assets/images/moved-to-follow-ups.svg">
        <h2 class="title">Moved to follow ups</h2>
        <p class="ut-mb-6">
          {{ $options.filters.titleCase(prospect.contact.firstName) }}
          {{ $options.filters.titleCase(prospect.contact.lastName) }}
          was moved to your follow ups list</p>
        <a @click="nextPage(page)"
           v-gaEvent="{ category: gacategory,
                               action: 'Contact card - go to follow up list'}"
           href="#follow-ups"
           class="btn btn-green">Go to follow up list</a>
        <button class="btn btn-small white-bg ut-ml-4"
                v-gaEvent="{ category: gacategory,
                               action: 'Contact card - back to prospects'}"
                @click="closeModal()">Cancel</button>
      </div>

    </div>
  </modal>
</template>

<script>
import moment from 'moment';
import { mapActions } from 'vuex';
import OaDatepicker from '../Forms/OaDatepicker';

export default {
  name: 'ProspectingFollowUpModal',
  components: { OaDatepicker },
  props: {
    agentId: {
      required: true,
    },
  },
  data() {
    return {
      name: 'prospecting-follow-up-modal',
      page: 1,
      disabledDates: {
        to: moment().subtract(1, 'days').toDate(),
      },
      followUpDate: '',
      followUpDateError: false,
      followUpNote: '',
      prospect: null,
      gacategory: 'Prospecting Tool Agent portal',
    };
  },
  methods: {
    ...mapActions('prospectsStore', [
      'updateProspect',
      'reloadProspectLists',
    ]),
    closeModal() {
      this.page = 1;
      this.$modal.hide(this.name);
    },
    beforeOpen(event) {
      this.page = 1;
      this.prospect = event.params;
      this.followUpDate = this.prospect.followUpDate;
      this.followUpNote = this.prospect.note;
    },
    beforeClose() {
      if (this.$route.params.pk) {
        this.$router.push({
          name: 'prospecting',
          params: { ak: this.$route.params.ak },
        });
      }
    },
    nextPage(currentPage) {
      if (currentPage === 1) {
        this.createFollowUp(currentPage);
      }

      if (currentPage === 2) {
        this.closeModal();
        // got to follow up list
      }
    },
    createFollowUp(currentPage) {
      this.followUpDateError = false;

      if (!this.followUpDate || this.followUpDate === '') {
        this.followUpDateError = true;
        return false;
      }

      const payload = {
        agentId: this.agentId,
        prospectKey: this.prospect.key,
        data: {
          followUp: true,
          followUpDate: this.$helpers.formatDateTimeApi(this.followUpDate),
          note: this.followUpNote,
        },
      };

      this.updateProspect(payload).then(() => {
        const reloadData = {
          agentId: this.agentId,
          current: this.prospect.currentList,
          new: this.prospect.currentList !== 'followUps' ? 'followUps' : null,
        };

        this.reloadProspectLists(reloadData);
        // Move to next page
        this.page = currentPage + 1;
      });

      return true;
    },
  },
};
</script>

<style scoped lang="scss">
.title {
  @apply ut-font-bold ut-mb-6;
  font-size: 20px;

}

hr {
  @apply ut-border-t ut-opacity-50 ut-w-full ut-h-auto;
  border-color: #979797;
}

.address {
  @apply ut-my-6 ut-flex ut-font-bold;
}

.property-details {
  @apply ut-flex ut-my-6;

  ul {
    @apply  ut-flex;

    li {
      @apply ut-ml-6;

      img {
        vertical-align: sub;
      }
    }
  }
}

.contact-details {
  @apply ut-my-6;

  ul {
    li {
      @apply ut-my-6;

      a {
        @apply ut-text-green-400;
      }
    }
  }
}
</style>
